import {LANGUAGE} from '@/common/utils/constants';

export const DRC_SUBSCRIPTIONS = {
	[LANGUAGE.en.short]: {
		title: 'Title',
		titlePlaceholder: 'Subscription title here',
		comment: 'Comment',
		commentPlaceholder: 'Message here',
		period: 'Period',
		selectMoreFollowing: 'Select one or more of the following',
		selectConfidentiality: 'Select one or more confidentiality',
		goBack: "Go Back",
		newSubscriptions: "New Subscription",
		create: 'Create',
		update: 'Update',
		history: "Subscription History",
		info: 'Below you can find your subscription reports. Click to view.',
		receivedOn: 'Sent on ',
		errors: {
			required: "The field is required",
			'lengthBetween-0-250': `The symbols count must be between 0 and 250`,
			'lengthBetween-0-1000': 'The symbols count must be between 0 and 1000',
		},
		cancelFormConfirmation: 'Are you sure you want to exit the subscription form? If you have some unsaved data it will be lost.',
		successSubmit: 'The subscription was successfully created.',
		active: 'Active',
		notActive: 'Not Active',
		WEEKLY: 'Weekly',
		MONTHLY: 'Monthly',
		QUARTERLY: 'Quarterly',
		newSubscription: 'New Subscription',
		mySubscriptionsPage: 'My Subscriptions',
		mySubscriptionsPageTooltip: 'Manage your subscription settings by creating and customizing subscriptions, assigning ' +
			'names, choosing filters, selecting types, and setting delivery frequency. <br><br>You can also start, stop, delete ' +
			'subscriptions, and access detailed reports in your Subscription History.',
		edit: 'Edit',
		stop: 'Stop',
		delete: 'Delete',
		activate: 'Activate',
		successStop: 'The subscription was successfully stopped.',
		successActive: 'The subscription was successfully activated.',
		noneSelected: 'None selected',
		subscriptionDeleteSuccess: 'The subscription was successfully deleted.',
		noSubscriptions: 'You currently have no subscriptions',
		getSubscribed: 'Subscribe today to get the latest updates',
		confirmDelete: 'Are you sure you want to delete the subscription - ',
		successSubscribed: 'You have been successfully subscribed.',
		successUnsubscribed: 'You are successfully unsubscribed.',
		sameTitleAndPeriod: 'A subscription with this title and period already exists.',
		noProjects: 'There are no published projects for this period',
		clientLocations: `Client's Locations`,
		searchBusinessContactManagers: 'Search for business manager',
		searchDeliveryContactManagers: 'Search for delivery manager',
		notValidForm: 'Some fields are not selected properly. Please edit where necessary.',
		viewReports: 'View reports'
	},
	[LANGUAGE.de.short]: {
		title: 'Titel',
		titlePlaceholder: 'Abonnementtitel hier',
		comment: 'Kommentar',
		commentPlaceholder: 'Nachricht hier',
		period: 'Zeitraum',
		selectMoreFollowing: 'Wählen Sie eine oder mehrere der folgenden Optionen',
		selectConfidentiality: 'Wählen Sie eine oder mehrere Vertraulichkeits',
		goBack: "Geh zurück",
		newSubscriptions: "Neues Abonnement",
		create: 'Erstellen',
		update: 'Aktualisieren',
		history: "Abonnementverlauf",
		info: 'Unten finden Sie Ihre Abonnementberichte. Klicken Sie hier, um sie anzuzeigen.',
		receivedOn: 'Gesendet am ',
		errors: {
			required: "Das Feld ist nicht erforderlich",
			'lengthBetween-0-250': `Die Anzahl der Symbole muss zwischen 0 und 250 liegen`,
			'lengthBetween-0-1000': 'Die Anzahl der Symbole muss zwischen 0 und 1000 liegen',
		},
		cancelFormConfirmation: 'Möchten Sie das Anmeldeformular wirklich verlassen? Ungespeicherte Daten gehen verloren.',
		successSubmit: 'Das Abonnement wurde erfolgreich erstellt.',
		active: 'Aktiv',
		notActive: 'Nicht aktiv',
		WEEKLY: 'Wöchentlich',
		MONTHLY: 'Monatlich',
		QUARTERLY: 'Vierteljährlich',
		newSubscription: 'Neues Abonnement',
		mySubscriptionsPage: 'Meine Abonnements',
		mySubscriptionsPageTooltip: 'Verwalten Sie Ihre Abonnementeinstellungen, indem Sie Abonnements erstellen und ' +
			'anpassen, Namen zuweisen, Filter auswählen, Typen auswählen und die Lieferhäufigkeit festlegen. <br><br>Sie ' +
			'können Abonnements auch starten, beenden, löschen und auf detaillierte Berichte in Ihrem Abonnementverlauf zugreifen.',
		edit: 'Bearbeiten',
		stop: 'Stoppen',
		delete: 'Löschen',
		activate: 'Aktivieren',
		successStop: 'Das Abonnement wurde erfolgreich beendet.',
		successActive: 'Das Abonnement wurde erfolgreich aktiviert.',
		noneSelected: 'Keine ausgewählt',
		subscriptionDeleteSuccess: 'Das Abonnement wurde erfolgreich gelöscht.',
		noSubscriptions: 'Sie haben derzeit keine Abonnements',
		getSubscribed: 'Abonnieren Sie noch heute, um die neuesten Updates zu erhalten',
		confirmDelete: 'Möchten Sie das Abonnement wirklich löschen -',
		successSubscribed: 'Ihr Abonnement wurde erfolgreich abgeschlossen.',
		successUnsubscribed: 'Ihre Abmeldung ist erfolgreich.',
		sameTitleAndPeriod: 'Ein Abonnement mit diesem Titel und Zeitraum existiert bereits.',
		noProjects: 'Für diesen Zeitraum sind keine Projekte veröffentlicht',
		clientLocations: 'Standorte des Kunden',
		searchBusinessContactManagers: 'Suche nach Business Manager',
		searchDeliveryContactManagers: 'Suche nach Delivery Manager',
		notValidForm: 'Einige Felder sind nicht richtig ausgewählt. Bitte korrigieren Sie sie gegebenenfalls.',
		viewReports: 'Berichte ansehen'
	},
	[LANGUAGE.fr.short]: {
		title: 'Titre',
		titlePlaceholder: 'Titre de l\'abonnement ici',
		comment: 'Commentaire',
		commentPlaceholder: 'Message ici',
		period: 'Période',
		selectMoreFollowing: 'Sélectionnez une ou plusieurs des options suivantes',
		selectConfidentiality: 'Sélectionnez une ou plusieurs confidentialités',
		goBack: "Retourner",
		newSubscriptions: "Nouvel abonnement",
		create: 'Créer',
		update: 'Mise à jour',
		history: "Historique des abonnements",
		info: 'Vous trouverez ci-dessous vos rapports d\'abonnement. Cliquez pour voir.',
		receivedOn: 'Envoyé le ',
		errors: {
			required: "Ce champ est obligatoire",
			'lengthBetween-0-250': `Le nombre de symboles doit être compris entre 0 et 250`,
			'lengthBetween-0-1000': 'Le nombre de symboles doit être compris entre 0 et 1000',
		},
		cancelFormConfirmation: 'Voulez-vous vraiment quitter le formulaire d\'abonnement ? Si vous avez des données non enregistrées, elles seront perdues.',
		successSubmit: 'L\'abonnement a été créé avec succès.',
		active: 'Actif',
		notActive: 'Pas actif',
		WEEKLY: 'Hebdomadaire',
		MONTHLY: 'Mensuel',
		QUARTERLY: 'Trimestriel',
		newSubscription: 'Nouvel abonnement',
		mySubscriptionsPage: 'Mes abonnements',
		mySubscriptionsPageTooltip: 'Gérez vos paramètres d\'abonnement en créant et en personnalisant des abonnements, en ' +
			'attribuant des noms, en choisissant des filtres, en sélectionnant des types et en définissant la fréquence de ' +
			'livraison. <br><br>Vous pouvez également démarrer, arrêter, supprimer des abonnements et accéder à des rapports ' +
			'détaillés dans votre historique d\'abonnement.',
		edit: 'Modifier',
		stop: 'Arrêt',
		delete: 'Supprimer',
		activate: 'Activer',
		successStop: 'L\'abonnement a été arrêté avec succès.',
		successActive: 'L\'abonnement a été activé avec succès.',
		noneSelected: 'Aucun sélectionné',
		subscriptionDeleteSuccess: 'L\'abonnement a été supprimé avec succès.',
		noSubscriptions: 'Vous n\'avez actuellement aucun abonnement',
		getSubscribed: 'Abonnez-vous aujourd\'hui pour recevoir les dernières mises à jour',
		confirmDelete: 'Êtes-vous sûr de vouloir supprimer l\'abonnement -',
		successSubscribed: 'Vous avez été inscrit avec succès.',
		successUnsubscribed: 'Vous avez été désabonné avec succès.',
		sameTitleAndPeriod: 'Un abonnement avec ce titre et cette période existe déjà.',
		noProjects: 'Il n\'y a aucun projet publié pour cette période',
		clientLocations: 'Emplacements des clients',
		searchBusinessContactManagers: 'Recherche de responsable commercial',
		searchDeliveryContactManagers: 'Recherche de responsable livraison',
		notValidForm: 'Certains champs ne sont pas correctement sélectionnés. Veuillez les modifier si nécessaire.',
		viewReports: 'Consulter les rapports'
	},
	[LANGUAGE.it.short]: {
		title: 'Titolo',
		titlePlaceholder: 'Titolo dell\'abbonamento qui',
		comment: 'Commento',
		commentPlaceholder: 'Messaggio qui',
		period: 'Periodo',
		selectMoreFollowing: 'Seleziona una o più delle seguenti opzioni',
		selectConfidentiality: 'Seleziona una o più riservatezza',
		goBack: "Torna indietro",
		newSubscriptions: "Nuovo abbonamento",
		create: 'Creare',
		update: 'Aggiornamento',
		history: "Cronologia degli abbonamenti",
		info: 'Qui sotto puoi trovare i report dei tuoi abbonamenti. Clicca per visualizzarli.',
		receivedOn: 'Inviato il ',
		errors: {
			required: "Il campo è obbligatorio",
			'lengthBetween-0-250': `Il conteggio dei simboli deve essere compreso tra 0 e 250`,
			'lengthBetween-0-1000': 'Il conteggio dei simboli deve essere compreso tra 0 e 1000',
		},
		cancelFormConfirmation: 'Vuoi davvero uscire dal modulo di iscrizione? Se hai dei dati non salvati, andranno persi.',
		successSubmit: 'L\'abbonamento è stato creato con successo.',
		active: 'Attivo',
		notActive: 'Non attivo',
		WEEKLY: 'Settimanale',
		MONTHLY: 'Mensile',
		QUARTERLY: 'Trimestrale',
		newSubscription: 'Nuovo abbonamento',
		mySubscriptionsPage: 'I miei abbonamenti',
		mySubscriptionsPageTooltip: 'Gestisci le impostazioni del tuo abbonamento creando e personalizzando gli abbonamenti,' +
			' assegnando nomi, scegliendo filtri, selezionando i tipi e impostando la frequenza di consegna. <br><br>Puoi anche ' +
			'avviare, interrompere, eliminare gli abbonamenti e accedere a report dettagliati nella cronologia degli abbonamenti.',
		edit: 'Modificare',
		stop: 'Fermare',
		delete: 'Eliminare',
		activate: 'Attivare',
		successStop: 'L\'abbonamento è stato interrotto correttamente.',
		successActive: 'L\'abbonamento è stato attivato con successo.',
		noneSelected: 'Nessuno selezionato',
		subscriptionDeleteSuccess: 'L\'abbonamento è stato eliminato correttamente.',
		noSubscriptions: 'Al momento non hai abbonamenti',
		getSubscribed: 'Iscriviti oggi per ricevere gli ultimi aggiornamenti',
		confirmDelete: 'Sei sicuro di voler eliminare l\'abbonamento -',
		successSubscribed: 'La tua iscrizione è avvenuta con successo.',
		successUnsubscribed: 'La tua iscrizione è stata annullata con successo.',
		sameTitleAndPeriod: 'Un abbonamento con questo titolo e periodo esiste già.',
		noProjects: 'Non ci sono progetti pubblicati per questo periodo',
		clientLocations: 'Posizioni del cliente',
		searchBusinessContactManagers: 'Cerca responsabile commerciale',
		searchDeliveryContactManagers: 'Cerca responsabile delle consegne',
		notValidForm: 'Alcuni campi non sono selezionati correttamente. Si prega di modificarli dove necessario.',
		viewReports: 'Visualizza i report'
	},
	[LANGUAGE.ja.short]: {
		title: 'タイトル',
		titlePlaceholder: 'サブスクリプションタイトルをここに入力',
		comment: 'コメント',
		commentPlaceholder: 'ここにメッセージ',
		period: '期間',
		selectMoreFollowing: '以下の1つ以上を選択してください',
		selectConfidentiality: '1つ以上の機密性を選択してください',
		goBack: "戻る",
		newSubscriptions: "新規購読",
		create: '作成する',
		update: 'アップデート',
		history: "購読履歴",
		info: '以下にサブスクリプション レポートがあります。クリックして表示してください。',
		receivedOn: '送信済み ',
		errors: {
			required: "このフィールドは必須です",
			'lengthBetween-0-250': `シンボル数は0から250の間でなければなりません`,
			'lengthBetween-0-1000': 'シンボル数は0から1000の間でなければなりません',
		},
		cancelFormConfirmation: 'サブスクリプションフォームを終了してもよろしいですか? 保存されていないデータがある場合は失われます。',
		successSubmit: 'サブスクリプションが正常に作成されました。',
		active: 'アクティブ',
		notActive: '非アクティブ',
		WEEKLY: '週刊',
		MONTHLY: '月次',
		QUARTERLY: '四半期ごと',
		newSubscription: '新規購読',
		mySubscriptionsPage: '私の購読',
		mySubscriptionsPageTooltip: 'サブスクリプションの作成とカスタマイズ、名前の割り当て、フィルターの選択、タイプの選択、配信頻度の設定を行' +
			'って、サブスクリプション設定を管理します。<br><br>また、サブスクリプションを開始、停止、削除したり、サブスクリプション履歴で詳細なレポート' +
			'にアクセスしたりすることもできます。',
		edit: '編集',
		stop: '停止',
		delete: '消去',
		activate: '活性化',
		successStop: 'サブスクリプションは正常に停止されました。',
		successActive: 'サブスクリプションは正常にアクティブ化されました。',
		noneSelected: '選択なし',
		subscriptionDeleteSuccess: 'サブスクリプションは正常に削除されました。',
		noSubscriptions: '現在、サブスクリプションはありません',
		getSubscribed: '最新情報を受け取るには今すぐ購読してください',
		confirmDelete: 'サブスクリプションを削除してもよろしいですか？',
		successSubscribed: '購読が完了しました。',
		successUnsubscribed: '購読解除が完了しました。',
		sameTitleAndPeriod: 'このタイトルと期間のサブスクリプションはすでに存在します。',
		noProjects: 'この期間に公開されたプロジェクトはありません',
		clientLocations: 'クライアントの所在地',
		searchBusinessContactManagers: 'ビジネスマネージャーを検索',
		searchDeliveryContactManagers: 'デリバリーマネージャーを検索',
		notValidForm: '一部のフィールドが正しく選択されていません。必要に応じて編集してください。',
		viewReports: 'レポートを表示'
	},
	[LANGUAGE.es.short]: {
		title: 'Título',
		titlePlaceholder: 'Título de la suscripción aquí',
		comment: 'Comentario',
		commentPlaceholder: 'Mensaje aquí',
		period: 'Período',
		selectMoreFollowing: 'Seleccione una o más de las siguientes opciones',
		selectConfidentiality: 'Seleccione una o más confidencialidades',
		goBack: "Regresar",
		newSubscriptions: "Nueva Suscripción",
		create: 'Crear',
		update: 'Actualizar',
		history: "Historial de Suscripciones",
		info: 'A continuación encontrará sus informes de suscripción. Haga clic para ver.',
		receivedOn: 'Enviado el ',
		errors: {
			required: "El campo es obligatorio",
			'lengthBetween-0-250': `El recuento de símbolos debe estar entre 0 y 250`,
			'lengthBetween-0-1000': 'El recuento de símbolos debe estar entre 0 y 1000',
		},
		cancelFormConfirmation: '¿Está seguro de que desea salir del formulario de suscripción? Si tiene datos no guardados, se perderán.',
		successSubmit: 'La suscripción se creó correctamente.',
		active: 'Activo',
		notActive: 'No Activo',
		WEEKLY: 'Semanal',
		MONTHLY: 'Mensual',
		QUARTERLY: 'Trimestral',
		newSubscription: 'Nueva Suscripción',
		mySubscriptionsPage: 'Mis Suscripciones',
		mySubscriptionsPageTooltip: 'Administre la configuración de su suscripción creando y personalizando suscripciones, asignando nombres, eligiendo filtros, seleccionando tipos y estableciendo la frecuencia de entrega. <br><br>También puede iniciar, detener, eliminar suscripciones y acceder a informes detallados en su Historial de Suscripciones.',
		edit: 'Editar',
		stop: 'Detener',
		delete: 'Eliminar',
		activate: 'Activar',
		successStop: 'La suscripción se detuvo correctamente.',
		successActive: 'La suscripción se activó correctamente.',
		noneSelected: 'Ninguno seleccionado',
		subscriptionDeleteSuccess: 'La suscripción se eliminó correctamente.',
		noSubscriptions: 'Actualmente no tiene suscripciones',
		getSubscribed: 'Suscríbase hoy para recibir las últimas actualizaciones',
		confirmDelete: '¿Está seguro de que desea eliminar la suscripción -',
		successSubscribed: 'Te has suscrito correctamente.',
		successUnsubscribed: 'Te has dado de baja correctamente.',
		sameTitleAndPeriod: 'Ya existe una suscripción con este título y este período.',
		noProjects: 'No hay proyectos publicados para este período',
		clientLocations: 'Ubicaciones del cliente',
		searchBusinessContactManagers: 'Buscar gerente comercial',
		searchDeliveryContactManagers: 'Buscar gerente de entrega',
		notValidForm: 'Algunos campos no están seleccionados correctamente. Por favor, edítelos si es necesario.',
		viewReports: 'Ver informes'
	}
}
